import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import IconButton from '../../../Button/IconButton';
import s from './ItemControlButtons.scss';
export class ItemControlButtons extends React.Component {
    render() {
        const { t, menuItems, withOneClickDelete, moreMenuClassName, onDelete } = this.props;
        const iconProps = {
            withPadding: true,
            size: IconSize.SMALL
        };
        return /*#__PURE__*/ React.createElement("div", {
            onClick: this.onClick,
            className: classnames(s['root'], this.props.className)
        }, withOneClickDelete && /*#__PURE__*/ React.createElement(IconButton, {
            tooltipText: t('mediapopup.delete'),
            onClick: onDelete
        }, /*#__PURE__*/ React.createElement(TrashcanIcon, iconProps)), menuItems && /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
            contextMenuClassName: moreMenuClassName,
            items: menuItems,
            withButton: true
        }, /*#__PURE__*/ React.createElement(EllipsisIcon, iconProps)));
    }
    onClick(event) {
        event.stopPropagation();
    }
}
export default withTranslation()(ItemControlButtons);
